import { use } from 'react';
import { HeaderActionsContext } from 'contexts/HeaderActionsContext';

export function useHeaderActions() {
  return use(HeaderActionsContext);
}
